import { hasTouchScreen, hasCoarsePointer } from "./deviceCapture";

export const getScreenSignals = () => {
  if (typeof window === "undefined" || !window.screen) return null;
  return {
    larguraTela: window.screen.width ?? null,
    alturaTela: window.screen.height ?? null,
    devicePixelRatio: window.devicePixelRatio ?? null,
  };
};

export const getDeviceType = () => {
  if (!hasTouchScreen() && !hasCoarsePointer()) return "Desktop";

  const sinais = getScreenSignals();
  if (!sinais?.larguraTela || !sinais?.alturaTela) return "Mobile";

  return Math.min(sinais.larguraTela, sinais.alturaTela) >= 500 ? "Tablet" : "Mobile";
};

export const getClientHints = async () => {
  const uaData = typeof navigator !== "undefined" ? navigator.userAgentData : null;
  if (!uaData?.getHighEntropyValues) return null;

  try {
    const hints = await uaData.getHighEntropyValues(["model", "platform", "platformVersion"]);
    return {
      modelo: hints.model || null,
      plataforma: hints.platform || null,
      versaoPlataforma: hints.platformVersion || null,
      mobileHint: uaData.mobile ?? null,
    };
  } catch {
    return null;
  }
};

export const getDeviceInfo = async () => ({
  dispositivo: getDeviceType(),
  ...getScreenSignals(),
  maxTouchPoints: typeof navigator !== "undefined" ? navigator.maxTouchPoints ?? null : null,
  userAgent: typeof navigator !== "undefined" ? navigator.userAgent : null,
  ...((await getClientHints()) ?? {}),
});

export default getDeviceType;
